import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../Login/styles.css';
import IconButton from '../../../components/IconButton';
import { FaExternalLinkAlt, FaLink } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getText, getEventLanguage } from '../../../util/translations';
import Processando from '../../../components/Processando';

export default function CadastroEventoParticipanteConviteConcluido({ match }) {
  const id = match.params.id;
  const token = localStorage.getItem('token');
  const [evento, setEvento] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const history = useHistory();
  let { state } = useLocation();

  // Pega o idioma do state ou da URL, ou usa 'portugues' como padrão
  const idioma = state?.idioma || new URLSearchParams(window.location.search).get('idioma') || 'portugues';

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      toast.error(getText('error', idioma) + getText('errorDefault', idioma));
    });
  };//buscar

  /*
  const salvar = () => {
    api({
      method: 'put',
      action: '/participante/concluirConfirmacaoDados/' + id,
      token: token,
    })
      .then(function (response) {
      })
      .catch(function (error) {
        //alert(error)
      });
  }; //salvar
  */

  useEffect(() => { //onload
    buscar();
    //salvar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div id="auth" style={{
      backgroundImage: "none",
      backgroundColor: evento?.cor ?? "#AAAAAA",
    }}>
      {isLoading && <Processando idioma={idioma} />}
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  {localStorage.getItem('logomarcaEvento') ?
                    <img alt="" src={localStorage.getItem('logomarcaEvento')} height="48" className='mb-4' /> :
                    <img alt="" src={logo} height="48" className='mb-4' />
                  }
                  <p>
                    {getText('presenceConfirmed', idioma)} <strong>{evento?.nome ?? ""}</strong>, {getText('moreDetailsSoon', idioma)}<br />
                    {getText('contactInfo', idioma)}</p>
                  {id !== '990983771759499923' && (
                    <p>{getText('accessGroup', idioma)}<br />
                      {getText('phone', idioma)}</p>
                  )}
                  {((evento.linkfinalcadastro ?? "") !== '') ?
                    <>
                      <p>{getText('clickBelowAccess', idioma)}</p>
                      <IconButton
                        target="_blank"
                        title={getText('accessContent', idioma)}
                        color="primary"
                        icon={<FaExternalLinkAlt size={20} />}
                        to={{
                          pathname: evento.linkfinalcadastro,
                        }}>{getText('accessContent', idioma)}</IconButton>
                    </>
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
